import { APP_VERSION } from '../version';

export function VersionBadge() {
  return (
    <span className="badge" title="Versión del Service Worker / app">
      <span style={{ width: 7, height: 7, borderRadius: 99, background: 'var(--amber)' }} />
      {APP_VERSION}
    </span>
  );
}
